import modelMapping from '../resources/model_mapping.json';

const appendName = (namespace, name) => {
  return namespace ? `${namespace}_${name}` : name;
};

// ダッシュボード関連で他画面と共通のもの
// 需要者以外トップタブ１
export const homeAdminTab1Mixin = (namespace = '') => {
  const named = (name) => {
    return appendName(namespace, name);
  };
  return {
    data: () => ({
      [named('items')]: [],
      [named('sum')]: {
        devicesCount: undefined,
        alermCount: undefined,
        alermCountMaintenance: undefined,
        alermCountCaution: undefined,
        alermCountEmergency: undefined,
        drivingCount: undefined,
        notDrivingCount: undefined,
        connectionOffCount: undefined,
        communicatedCount: undefined,
        notCommunicatedCount: undefined,
        notReceivedTheConsentForm: undefined,
      },
      [named('apiUrl')]: [],
      [named('nameHistory')]: [],
      [named('previousSourceType')]: null,
      [named('APITable')]: [],
      [named('deviceGroupData')]: [],
      [named('allSourceType')]: [],
      [named('devices')]: [],
    }),
    computed: {
      [named('groupAuthritesInit')]() {
        return this.$store.getters['groupAuthorities/getInitialized']();
      },
      [named('groupId')]() {
        return this[named('value')];
      },
    },
    methods: {
      async [named('getGroup')](
        isDeviceCount = true,
        isAlermCount = false,
        isUnderDevice = false,
        isContinue = () => {
          return true;
        }
      ) {
        const groupId = this[named('groupId')];
        const currentGroup = await this.$store.getters['groupAuthorities/getGroup'](groupId);

        if (currentGroup) {
          const children = currentGroup.children;
          if (children) {
            children.sort((a, b) => {
              // localeIdはページ側の処理を使う
              const aa = a[`device_group_name_locale${this.localeId}`];
              const bb = b[`device_group_name_locale${this.localeId}`];
              return aa.localeCompare(bb);
            });

            this[named('items')] = children.map((el) => {
              el.additional = {};
              return el;
            });
            //await this[named('addInfo')]();
            await this[named('_addInfoCtrl')](isDeviceCount, isAlermCount, isUnderDevice, isContinue);
          }
        }
      },
      //--追加情報取得処理 ここから---------------------
      async [named('clickAddInfoDetail')]() {
        this.$store.commit('loading/start_loading');
        try {
          // 下層を集計する
          await this[named('_addInfoCtrl')](false, true, true);
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },
      async [named('openPage')]() {
        this.$store.commit('loading/start_loading');
        const groupId = this[named('groupId')];
        const currentGroup = await this.$store.getters['groupAuthorities/getGroup'](groupId);
        console.log(currentGroup);
        try {
          this.$router.push({
            name: 'AlermMailSetting',
            params: {
              device_group_id: this[named('user_info')].deviceGroupId,
              group_id: currentGroup.device_group_id,
              device_group_name_locale: currentGroup.device_group_name_locale1,
            },
          });
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },
      async [named('addInfo')]() {
        console.log('初期追加分');
        // アラーム発砲中、管理台数を取得
        await this[named('_addInfoCtrl')](true, false, false);
      },
      async [named('_addInfoCtrl')](
        isDeviceCount,
        isAlermCount,
        isUnderDevice,
        isContinue = () => {
          return true;
        }
      ) {
        this[named('devices')] = [];
        console.log('追加情報取得 開始');
        let counter = 0;
        for (const deviceGroup of this[named('items')]) {
          counter++;
          if (!isContinue()) {
            return;
          }
          const devices =
            isDeviceCount || isUnderDevice ? await this[named('_addInfo_getAllDevices')](deviceGroup) : undefined;

          this[named('devices')].push(...devices);

          if (isDeviceCount) {
            // 所属する全デバイスを取得
            console.log(`全デバイス取得 ${devices.length}`);
            deviceGroup.additional.devicesCount = devices.length;

            if (!this[named('sum')].devicesCount) {
              this[named('sum')].devicesCount = 0;
            }
            this[named('sum')].devicesCount += devices.length;
          }

          if (isAlermCount) {
            // 所属する全デバイスを取得
            console.log('アラーム取得');
            const { total, maintenance, caution, emergency } = await this[named('_addInfo_getAlermDeviceCount')](
              deviceGroup
            );

            if (!this[named('sum')].alermCount) {
              this[named('sum')].alermCount = 0;
              this[named('sum')].alermCountMaintenance = 0;
              this[named('sum')].alermCountCaution = 0;
              this[named('sum')].alermCountEmergency = 0;
            }

            deviceGroup.additional.alermCount = total;
            this[named('sum')].alermCount += total;

            deviceGroup.additional.alermCountMaintenance = maintenance;
            this[named('sum')].alermCountMaintenance += maintenance;

            deviceGroup.additional.alermCountCaution = caution;
            this[named('sum')].alermCountCaution += caution;

            deviceGroup.additional.alermCountEmergency = emergency;
            this[named('sum')].alermCountEmergency += emergency;
          }

          if (isUnderDevice) {
            console.log('運転中関連取得');
            const [drivingCount, notDrivingCount, connectionOffCount, communicatedCount, notCommunicatedCount] =
              await this[named('_addInfo_getSensorDataCount')](devices);

            deviceGroup.additional.drivingCount = drivingCount;
            deviceGroup.additional.notDrivingCount = notDrivingCount;
            deviceGroup.additional.connectionOffCount = connectionOffCount;
            deviceGroup.additional.communicatedCount = communicatedCount;
            deviceGroup.additional.notCommunicatedCount = notCommunicatedCount;

            const notReceivedTheConsentForm = await this[named('_addInfo_getNotReceivedTheConsentForm')](devices);
            if (notReceivedTheConsentForm) {
              deviceGroup.additional.notReceivedTheConsentForm = notReceivedTheConsentForm;
            }
          }
        }

        const sumCalc = (a, b, key) => {
          return b.additional[key] === undefined ? a : a + b.additional[key];
        };

        this[named('sum')] = {
          devicesCount: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'devicesCount');
          }, 0),
          alermCount: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'alermCount');
          }, 0),
          alermCountMaintenance: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'alermCountMaintenance');
          }, 0),
          alermCountCaution: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'alermCountCaution');
          }, 0),
          alermCountEmergency: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'alermCountEmergency');
          }, 0),
          drivingCount: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'drivingCount');
          }, 0),
          notDrivingCount: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'notDrivingCount');
          }, 0),
          connectionOffCount: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'connectionOffCount');
          }, 0),
          communicatedCount: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'communicatedCount');
          }, 0),
          notCommunicatedCount: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'notCommunicatedCount');
          }, 0),
          notReceivedTheConsentForm: this[named('items')].reduce((a, b) => {
            return sumCalc(a, b, 'notReceivedTheConsentForm');
          }, 0),
        };

        // 再描画するために一旦クリアする
        const tmp = this[named('items')];
        this[named('items')] = [];
        this[named('items')] = tmp;
        console.log('追加情報取得 終了');
      },
      async [named('_addInfo_getNotReceivedTheConsentForm')](devices) {
        // 同意書未の件数を集計
        if (devices.length === 0) {
          return undefined;
        }

        // Smartpassのサービス実績情報を取得
        const codes = devices.map((item) => {
          // 取引先コード＝需要家コードの前提
          return `${item.serial_no.replace(/^.*_/, '')}`;
        });
        const codesTmp = [...new Set(codes)];
        const reports = await this.azureRequest(`/api/getSmartpassCustomers`, 'POST', {
          codes: codesTmp,
        });
        if (reports) {
          // 0 = 未確認
          const notReceived = reports.filter((el) => el.kobelinkAgreement === '0');
          return notReceived.length;
        }

        return undefined;
      },
      async [named('_addInfo_getAlermDeviceCount')](group) {
        // アラームを取得
        const params = {
          get_class: '4',
          sort: '-event_time',
          event_level: '1,2,3',
          parent_flg: 'true',
          incident_class: '1',
          device_group_id: group.device_group_id,
        };

        const res = await this.apiRequest('/v1/alarm-event-mgt/eventIncidentStatus', 'GET', params);

        if (res) {
          const byEvent_level = (event_level) => {
            const target = event_level ? res.filter((el) => el.event_level === event_level) : res;
            // 重複を排除するために一意になるキーを作成 Setで重複を除去
            return target ? new Set(target.map((el) => `${el.model_id}- ${el.serial_no}`)).size : 0;
          };

          const total = byEvent_level();
          const maintenance = byEvent_level('1');
          const caution = byEvent_level('2');
          const emergency = byEvent_level('3');

          return { total, maintenance, caution, emergency };
        }
        return { total: 0, maintenance: 0, caution: 0, emergency: 0 };
      },
      async [named('_addInfo_getSensorDataCount')](devices) {
        // 運転データ関連
        // 1回で運転データを取得する数 多すぎるとエラーになるので分割して取得
        const DIVID_COUNT = 5;
        const sensors = await devices.map((el) => {
          return {
            model_id: el.model_id,
            serial_no: el.serial_no,
            sensorId: 'sn_D027',
          };
        });

        // 分割して取得
        const splited = this[named('_util_split')](sensors, DIVID_COUNT);
        let apiResult = [];
        for (const tmp of splited) {
          const params = {
            sensor_list: tmp,
          };
          // センサーデータを取得
          const res = await this.apiRequest('/v1/sensor-data-file-mgt/getLatestSensorData', 'POST', params);
          if (res) {
            apiResult = apiResult.concat(res);
          }
        }

        if (apiResult) {
          const compressors = await apiResult.map((el) => {
            let compressor = {};
            // LED ランプ状態(Hex)のオブジェクトのみ抽出
            const panelLamp = el.timeList.filter((item) => item.sensorId === 'sn_D027');
            // センサーのデータリスト配列が空の場合未疎通とみなす
            if (panelLamp[0].dataList.length > 0) {
              // 10進数を2進数に変換し、1桁ずつ配列に分け配列を逆順にする
              const lampDatas = Number(panelLamp[0].dataList[0].data).toString(2).match(/.{1}/g).reverse();
              const mapping = modelMapping[el.modelId];
              // Startフラグ
              compressor.start = Boolean(lampDatas[mapping.start] === '1');
              // getLatestSensorDataは日付の文字列が特殊なので変換
              const fromDate = this[named('_util_getMomentObj')](panelLamp[0].dataList[0].measureTime);
              const toDate = this.$moment.utc();
              const diffDate = toDate.diff(fromDate, 'minutes');
              // 最新のデータ取得時刻が現在の時刻と比べて160分以上前であれば「通信断」と判定
              compressor.connection = Boolean(diffDate < 160);
            }
            return compressor;
          });

          // ・運転中：ロータのアニメが動いているコンプレッサをカウント。
          const drivingCount = compressors.reduce((pre, current) => {
            return current.start && current.connection ? pre + 1 : pre;
          }, 0);
          // ・通信断： ×付のアンテナマークがついているコンプレッサをカウント。
          const connectionOffCount = compressors.reduce((pre, current) => {
            return current.connection ? pre : pre + 1;
          }, 0);
          // ・停止中：全デバイスから運転中と通信断を除いたもの
          const notDrivingCount = devices.length - drivingCount - connectionOffCount;
          // ・疎通済：過去に運転データを取得できたことがあるコンプレッサをカウント。(上のループで設定されている項目)
          const communicatedCount = compressors.filter((el) => el.start !== undefined).length;
          // ・未疎通：過去に運転データを取得できたことがないコンプレッサをカウント。
          const notCommunicatedCount = devices.length - communicatedCount;
          //console.log(`運転中:${drivingCount} 停止中:${notDrivingCount} 通信断:${connectionOffCount} 疎通済:${communicatedCount} 未疎通:${notCommunicatedCount}`)
          return [drivingCount, notDrivingCount, connectionOffCount, communicatedCount, notCommunicatedCount];
        }
        return [0, 0, 0, 0];
      },
      async [named('_addInfo_getAllDevices')](deviceGroup) {
        // 全デバイスを取得するためのコールバック
        const getAllDevices = async (group, getDevice) => {
          const devices = await getDevice(group.device_group_id);
          return devices;
        };
        // グループに所属する全デバイスを取得する
        return await this.$store.getters['groupAuthorities/searchGroup'](deviceGroup.device_group_id, getAllDevices);
      },
      [named('_util_split')](array, number) {
        const length = Math.ceil(array.length / number);
        return new Array(length).fill().map((_, i) => array.slice(i * number, (i + 1) * number));
      },
      // measureTimeをmomentオブジェクトに変換
      [named('_util_getMomentObj')](value) {
        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const date = value.substring(6, 8);
        const hour = value.substring(8, 10);
        const min = value.substring(10, 12);
        const sec = value.substring(12, 14);
        // const msec = value.substring(14, 20)
        return this.$moment.utc(`${year}-${month}-${date} ${hour}:${min}:${sec}`);
      },
      //--追加情報取得処理 ここまで---------------------
    },
  };
};
// アラーム履歴
export const alermHistoryMixin = (namespace = '') => {
  const named = (name) => {
    return appendName(namespace, name);
  };
  return {
    data: () => ({
      [named('searchObject')]: {
        eventLevelM: true,
        eventLevelC: true,
        eventLevelE: true,
        repaired: false,
      },
      [named('selected')]: null, // 行選択中のアイテム
      [named('deviceName')]: null,
      [named('optionalInfo')]: null,
      [named('deviceGroupId')]: null,
      [named('modelId')]: null,
      [named('serialNo')]: null,
      [named('groupId')]: null,
      [named('compressors')]: null,
      [named('items')]: [],
      [named('loading')]: false,
      [named('timeoutObj')]: null,
    }),
    computed: {
      [named('isDevice')]() {
        // パラメータにデバイスが指定されているか？
        return this[named('modelId')] !== undefined && this[named('serialNo')] !== undefined;
      },
      [named('headers')]() {
        return [
          { text: this.$t('alarmName'), align: 'start', value: 'name_locale' },
          { text: this.$t('serialNo'), align: 'start', value: 'device_name_locale' },
          { text: this.$t('model'), align: 'start', value: 'device_optional_info_1' },
          { text: this.$t('customerName'), align: 'start', value: 'device_group_name_locale' },
          { text: this.$t('customerSMachineNo'), align: 'start', value: 'device_optional_info_2' },
          { text: this.$t('value'), align: 'start', value: 'value' },
          { text: `${this.$t('time')}(YYYY/MM/DD)`, align: 'start', value: 'browserLocalTime' },
          { text: `${this.$t('localTime')}(YYYY/MM/DD)`, align: 'start', value: 'localTime' },
        ];
      },
    },
    methods: {
      async [named('getGroups')](deviceGroupId, groupId) {
        if (groupId) {
          switch (groupId) {
            case 'all': {
              // allの場合は、deviceGroupIdでアラーム履歴をとる
              break;
            }
            case 'unset': {
              // 全デバイスを取得
              const allDevices = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
                device_group_id: deviceGroupId,
              });

              if (allDevices && allDevices.length > 0) {
                // 普遍的な需要家コードをserialNoから取得
                const consumerId = `${allDevices[0].serial_no.replace(/^.*_/, '')}$`;
                const allGroups = await this.azureRequest('/api/getGroups', 'GET', {
                  deviceGroupId: consumerId,
                });
                // グループに所属しているデバイス
                const groupedDevices = allGroups
                  .map((el) => el.devices)
                  .reduce((a, b) => {
                    return a.concat(b);
                  }, []);

                // グループに所属していないデバイスを抽出
                const nonGrouped = allDevices.filter(
                  (el) =>
                    !groupedDevices.find((d) => {
                      return el.model_id === d.modelId && el.serial_no === d.serialNo;
                    })
                );
                return nonGrouped.map((el) => {
                  return {
                    modelId: el.model_id,
                    serialNo: el.serial_no,
                  };
                });
              }
              break;
            }
            default: {
              const groups = await this.azureRequest('/api/getGroups', 'GET', {
                id: groupId,
              });
              return groups.devices;
            }
          }
        }
        return undefined;
      },
      async [named('selectedGroupChange')](group) {
        this.$router.push({
          name: group.children.length > 0 ? 'HomeAdmin' : 'HomeConsumer',
          params: { device_group_id: group.device_group_id },
        });
      },
      [named('selectedDeviceChange')](device) {
        if (this.$route.name !== 'CompressorInfo') {
          this.$router.push({
            name: 'CompressorInfo',
            params: { model_id: device.model_id, serial_no: device.serial_no },
          });
        }
      },
      async [named('getLabel')]() {
        // アラームが１件も取得できない場合もあるので個別に取得する
        if (this[named('isDevice')]) {
          try {
            // アラームを取得
            const res = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
              model_id: this[named('modelId')],
              serial_no: this[named('serialNo')],
            });
            const result = res[0];
            if (result !== null) {
              this[named('optionalInfo')] = result.optional_info_2;
              this[named('deviceName')] = result[`evice_name_locale${this.localeId}`];
              this[named('deviceGroupId')] = result.device_group_id;
            }
          } catch (error) {
            console.error(error);
          } finally {
            console.info('API完了');
          }
        }
      },

      async [named('setQueryParams')]() {
        let url = '/v1/alarm-event-mgt/eventIncidentStatus';
        let params = {
          get_class: '4',
          sort: '-event_time',
          event_level: '',
          parent_flg: 'true',
        };

        // 修復済み押下時は3(全て) 非押下時は1(発生)
        let incidentClass = '1';
        if (this[named('searchObject')].repaired) {
          // 修復済みは履歴APIを使用(eventIncidentStatusの場合、修復済みアラームは最新の1件しか取れない。履歴は全て記録されているため)
          url = '/v1/alarm-event-mgt/eventIncidentHistory';
          incidentClass = '3';

          // eventIncidentHistoryの場合は、event_time_from が必須 QA No26及びMTGから直近1年前分＋バッファ1か月分
          const fromDate = this.$moment()
            .add(-1, 'y')
            .add(-1, 'm')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss.SSSSSSS');
          params.event_time_from = fromDate;
        }
        params.incident_class = incidentClass;

        const eventLevels = [];
        if (this[named('searchObject')].eventLevelM) {
          eventLevels.push('1');
        }
        if (this[named('searchObject')].eventLevelC) {
          eventLevels.push('2');
        }
        if (this[named('searchObject')].eventLevelE) {
          eventLevels.push('3');
        }

        params.event_level = eventLevels.length > 0 ? eventLevels.join(',') : '1,2,3';

        if (this[named('isDevice')]) {
          params['device_list[0].model_id'] = this[named('modelId')];
          params['device_list[0].serial_no'] = this[named('serialNo')];
          params.device_group_id = this[named('deviceGroupId')];
          params.parent_flg = false;
        } else if (!this[named('groupId')] || this[named('groupId')] === 'all') {
          params.device_group_id = this[named('deviceGroupId')];
        } else if (this[named('compressors')]) {
          let index = 0;
          this[named('compressors')].forEach((el) => {
            params[`device_list[${index}].model_id`] = el.modelId;
            params[`device_list[${index}].serial_no`] = el.serialNo;
            index++;
          });

          params.device_group_id = this[named('deviceGroupId')];
          params.parent_flg = false;
        }
        return [url, params];
      },
      async [named('getAlermHistory')](isFirst, max_number = 100) {
        if (this[named('timeoutObj')] !== null) {
          clearTimeout(this[named('timeoutObj')]);
        }

        if (isFirst) {
          // 初期表示はモーダルのローディング
          this.$store.commit('loading/start_loading');

          await this[named('getLabel')]();
        } else {
          this[named('loading')] = true;
        }

        console.info('API開始');

        try {
          const [url, params] = await this[named('setQueryParams')]();
          // 画面は100件まで
          params.max_number = max_number;
          console.log(`params.max_number : ${params.max_number}`);
          console.log(params);

          // アラームを取得
          const res2 = await this.apiRequest(url, 'GET', params);

          let count = 0;
          let tmp = res2;

          if (tmp) {
            tmp.forEach((el) => {
              // ユニークなものがないためにitem-keyに設定するためのIDを付与
              el.id = count++;
              // ソートに使うためfiltersを使用しない
              el.value = this[named('valueLabel')](el.event_level, el.incident_class);
              // CSVでも同じ処理が必要なためfiltersを使用しない
              el.browserLocalTime = this[named('browserLocalTime')](el.event_time);
              el.localTime = this[named('localTime')](el.event_time, el.device_time_zone);
            });
            this[named('items')] = tmp;
          } else {
            this[named('items')] = [];
          }

          // 1分毎に再取得
          this[named('timeoutObj')] = setTimeout(this[named('getAlermHistory')], 60000);
        } catch (error) {
          console.error(error);
        } finally {
          console.info('API完了');
          if (isFirst) {
            this.$store.commit('loading/end_loading');
          }
          this[named('loading')] = false;
        }
      },
      [named('valueLabel')](event_level, incident_class) {
        if (event_level === undefined || incident_class === undefined) {
          return '';
        }

        if (incident_class === '1') {
          if (event_level === '1') {
            return this.$t('maintenance');
          } else if (event_level === '2') {
            return this.$t('caution');
          } else if (event_level === '3') {
            return this.$t('emergency');
          }
        } else if (incident_class === '2') {
          return this.$t('recovered');
        }
      },
      [named('eventLevelLabel')](value) {
        // event_levelの変換
        if (value === '3') {
          return 'E';
        } else if (value === '2') {
          return 'C';
        } else if (value === '1') {
          return 'M';
        }
      },

      [named('filterRepaired')](max_number = 100) {
        this[named('searchObject')].repaired = !this[named('searchObject')].repaired;
        this[named('getAlermHistory')](false, max_number);
      },
      [named('filterEventLevelE')](max_number = 100) {
        this[named('searchObject')].eventLevelE = !this[named('searchObject')].eventLevelE;
        this[named('getAlermHistory')](false, max_number);
      },
      [named('filterEventLevelC')](max_number = 100) {
        this[named('searchObject')].eventLevelC = !this[named('searchObject')].eventLevelC;
        this[named('getAlermHistory')](false, max_number);
      },
      [named('filterEventLevelM')](max_number = 100) {
        this[named('searchObject')].eventLevelM = !this[named('searchObject')].eventLevelM;
        this[named('getAlermHistory')](false, max_number);
      },

      [named('browserLocalTime')](date) {
        if (date === undefined) {
          return '';
        }
        // ブラウザのタイムゾーンを取得
        const offset = this.$moment().utcOffset();
        return this.$moment.utc(date).utcOffset(offset).format('YYYY/MM/DD HH:mm:ss');
      },
      [named('localTime')](date, timezone) {
        if (date === undefined) {
          return '';
        }
        // タイムゾーンが設定されていない場合はブラウザのタイムゾーンを使用する
        if (timezone === undefined || timezone === null) {
          const offset = this.$moment().utcOffset();
          return this.$moment.utc(date).utcOffset(offset).format('YYYY/MM/DD HH:mm:ss');
        }

        // UTC時刻とタイムゾーンから現地時間を返却
        return this.$moment.utc(date).utcOffset(timezone).format('YYYY/MM/DD HH:mm:ss');
      },
      [named('alermHighlight')](item) {
        // E,Cの場合に行の背景色を変更する
        const level = `alerm-history-highlight-${this[named('eventLevelLabel')](item.event_level)}`;
        // 選択行のハイライト
        if (this[named('selected')] !== null && item.id === this[named('selected')].id) {
          return 'alerm-history-selected';
        }
        return level;
      },
      [named('clickRow')](item) {
        // クリックされた行を選択行とする
        this[named('selected')] = item;
      },
    },
    beforeDestroy() {
      if (this[named('timeoutObj')]) {
        clearTimeout(this[named('timeoutObj')]);
        this[named('timeoutObj')] = null;
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this[named('timeoutObj')]) {
        clearTimeout(this[named('timeoutObj')]);
        this[named('timeoutObj')] = null;
      }
      next();
    },
  };
};
